import React, { useRef, useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "../style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import PreviewImage from "../../../Component/previewImage";
import useToast from "../../../provider/Toast/useToast";
import { apiAdminConfig } from "../../../utils/api";
import moment from 'moment';
import { FileBox } from "../../../Component/form";
import { MultiSelect } from "react-multi-select-component";

const AddEvents = () => {
  const [sponserList, setSponserList] = useState([]);
  const [sponsers, setSponsers] = useState([]);
  const [sponsersError, setSponsersError] = useState(false);
  const fileRef = useRef(null);
  const toast = useToast();
  const [field, setField] = useState([]);
  const navigate = useNavigate();

  const getSponser = async () => {
    await apiAdminConfig.get(`admin/sponser/getAll`).then((response) => {
      if (response?.data.status) {
        setSponserList(response?.data?.data?.map(list => ({
          label: list?.title ?? '',
          value: list?._id
        })) ?? [])
      }
    }).catch((error) => {
      console.log("sponsorError", error);
    })
  }
  React.useEffect(() => {
    getSponser();
  }, [])

  const validationSchema = yup.object().shape({
    image: yup.mixed().required("Image is a required"),
    title: yup.string().required("Title is a required"),
    organiser: yup.string().required("Event Organiser is a required"),
    content: yup.string().required("Event Content is a required"),
    // sponser_website: yup.string().required("Sponser Website is a required"),
    date: yup.string().required("Event Date is a required"),
    // bookingAmount: yup.string().matches(phoneRegExp, "Enter a valid number").required("Amount is a required"),
    bookingAmount: yup.string().required("Amount is a required"),
    address: yup.string().required("Address is a required"),
    // fees: yup.string().matches(phoneRegExp, "Enter a valid number").required("Fees is a required"),
  });

  const { handleSubmit, handleChange, setFieldValue, values, errors, touched, validateForm } =
    useFormik({
      initialValues: {
        title: "",
        organiser: "",
        content: "",
        date: "",
        time: moment().format("hh:mm:ss a"),
        bookingAmount: "",
        address: "Borivali Wes",
        image: null,
        sponsers: [],
      },
      validationSchema,

      onSubmit: async () => {
        if (sponsers?.length > 0) {
          await apiAdminConfig.post(`admin/events/add`, { ...values, sponsers }).then((response) => {
            if (response?.data.status) {
              navigate('/events')
              toast({
                message: response?.data?.message,
                bg: 'success'
              });
            } else {
              toast({
                message: response?.data?.message,
                bg: 'danger'
              });
            }
          }).catch((error) => {
            console.log("eventError", error)
            const { response } = error
            toast({
              message: response?.data?.message,
              bg: "danger",
            });
          })
        } else {
          setSponsersError(true)
        }
      },
    });

  return (
    <main id="events">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Add Events</h3>
            </div>
            <Link to="/events" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <FileBox
                        accept="image/*"
                        name="image"
                        label="ADD EVENT IMAGE"
                        onChange={(e) => {
                          setFieldValue("image", e)
                        }}
                        error={!!errors.image &&
                          touched.image && errors.image}
                        value={values?.image}
                        url="imageUpload/event"
                      />
                      {/* <Form.Control
                        hidden
                        type="file"
                        id="announcementsImage_id"
                        ref={fileRef}
                        name="image"
                        accept="image/*"
                        // value={values.image}
                        onChange={(event) => {
                          setFieldValue(
                            "image",
                            event.target.files[0]
                          );
                        }}
                        isInvalid={
                          !!errors.image &&
                          touched.image
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.image}
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col>
                    <div>
                      {values.image && (
                        <PreviewImage file={values.image} />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        TITLE<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                        isInvalid={!!errors.title && touched.title}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.title}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        EVENT ORGANISER<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="organiser"
                        value={values.organiser}
                        onChange={handleChange}
                        isInvalid={
                          !!errors.organiser && touched.organiser
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.organiser}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      CONTENT
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="content"
                      value={values.content}
                      onChange={handleChange}
                      isInvalid={
                        !!errors.content && touched.content
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.content}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        EVENT DATE<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="date"
                        min={new Date().toISOString().split('T')[0]}
                        value={values.date}
                        onChange={handleChange}
                        isInvalid={!!errors.date && touched.date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.date}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        ADD EVENT FEES
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="bookingAmount"
                        value={values.bookingAmount}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                          setFieldValue("bookingAmount", onlyNums)
                        }}
                        isInvalid={!!errors.bookingAmount && touched.bookingAmount}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.bookingAmount}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        SELECT SPONSERS<span className="text-danger">*</span>
                      </Form.Label>
                      <MultiSelect
                        options={sponserList ?? []}
                        className={sponsersError ? "multi-select-option-height error-multi-select" : "multi-select-option-height"}
                        value={sponsers?.map(val => sponserList?.find(list => list?.value == val)) ?? []}
                        onChange={(e) => {
                          setSponsersError(false)
                          setSponsers(e?.map(list => list?.value) ?? [])
                        }}
                        labelledBy="SELECT SPONSERS"
                      />
                      {sponsersError ? <p style={{
                        margin: 0,
                        marginTop: '0.25rem',
                        fontSize: '.875em',
                        color: '#dc3545'
                      }}>Sponsers is a required</p> : ""}
                    </Form.Group>
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Publish
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default AddEvents;
